import './scss/style.scss';
//import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'bootstrap/js/dist/index';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
// scrollspy dropped - no data-spy / .scrollspy anywhere in the templates
import 'bootstrap/js/dist/modal';
import lozad from 'lozad';
import './js/list.js';
import './js/globals.js';
import './js/contact.js';
import './js/inquiry.js';
import './js/newsletter.js';
import './js/analytics.js';
import './js/onboard.js';
import './js/review.js';

// details.js is 35kb and booking.js 17kb, and neither has anything to do
// outside its own page - both already bail on these markers
$(() => {
    if ($('.page-type-details')[0]) {
        import(/* webpackChunkName: "details" */ './js/details.js');
    }
    if ($('.booking-details-bg')[0]) {
        import(/* webpackChunkName: "booking" */ './js/booking.js');
    }
});

window.observer = lozad('.lozad', {
    loaded: el => {
       $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();